/**
 * PDP Shop the Look – slide-up size panel + AJAX add-to-cart
 */
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.pdp-shop-the-look');
  if (!section) return;

  var items = section.querySelectorAll('.stl-product-item');
  if (!items.length) return;

  /* ------------------------------------------------
   * Portal fix (overlay bug)
   * ------------------------------------------------
   * .stl-backdrop / .stl-size-panel live inside .content, and
   * .content is `position: sticky`, which always creates its own
   * CSS stacking context (true for fixed/sticky regardless of
   * z-index). That traps their huge z-index locally to .content,
   * so later sections in the DOM — e.g. the "You may also like"
   * recommendation slider, whose .swiper sets
   * position:relative + z-index:1 — can end up painting on top
   * of the backdrop/panel instead of being dimmed by/behind them.
   *
   * Fix: move the backdrop/panel nodes to a portal container
   * appended directly to <body>. That takes them out from under
   * the sticky ancestor, so their z-index is compared at the
   * document root against everything else on the page. The
   * portal keeps the "pdp-shop-the-look" class so every existing
   * `.pdp-shop-the-look .stl-backdrop` / `.stl-size-panel` CSS
   * selector keeps matching — no CSS changes needed.
   *
   * Because the nodes move out of `item`'s subtree, every place
   * that needs to reach a panel-scoped element (the close button,
   * variant radios, hidden variant id, "not selected" message,
   * panel add-to-cart button) must look it up via the panel
   * reference stashed on `item._stlPanel`, not via
   * `item.querySelector(...)`.
   */
  var stlPortal = document.querySelector('.pdp-shop-the-look-portal');
  if (!stlPortal) {
    stlPortal = document.createElement('div');
    stlPortal.className = 'pdp-shop-the-look-portal pdp-shop-the-look';
    document.body.appendChild(stlPortal);
  }

  /* ------------------------------------------------
   * Fetch current cart quantities for inventory checks
   * ------------------------------------------------ */
  function fetchCartQuantities() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = {};
        cart.items.forEach(function (item) {
          q[item.variant_id] = (q[item.variant_id] || 0) + item.quantity;
        });
        return q;
      })
      .catch(function () { return {}; });
  }

  fetchCartQuantities().then(function (cartQuantities) {

    items.forEach(function (item) {
      var trigger  = item.querySelector('.stl-select-trigger');
      var panel    = item.querySelector('.stl-size-panel');
      var backdrop = item.querySelector('.stl-backdrop');

      // Portal fix: relocate this item's backdrop/panel to <body>,
      // and stash references so we can still reach panel-scoped
      // elements from `item` later.
      if (backdrop) stlPortal.appendChild(backdrop);
      if (panel) stlPortal.appendChild(panel);
      item._stlPanel = panel;
      item._stlBackdrop = backdrop;

      var closeBtn    = panel ? panel.querySelector('.stl-panel-close') : null;
      var radios      = panel ? panel.querySelectorAll('.stl-variant-option input[type="radio"]') : [];
      var hiddenId    = panel ? panel.querySelector('.stl-variant-id') : null;
      var panelBtn    = panel ? panel.querySelector('.stl-panel-add-btn') : null;
      var notSelected = panel ? panel.querySelector('.stl-not-selected') : null;
      var triggerText = trigger ? trigger.textContent.trim() : '';

      function openPanel() {
        items.forEach(function (other) {
          if (other !== item) closeOtherPanel(other);
        });
        panel.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
        item.classList.add('panel-open');
      }

      function closePanel() {
        panel.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        item.classList.remove('panel-open');
      }

      function closeOtherPanel(otherItem) {
        var otherPanel = otherItem._stlPanel;
        if (otherPanel) otherPanel.classList.remove('is-open');
        var otherBackdrop = otherItem._stlBackdrop;
        if (otherBackdrop) otherBackdrop.classList.remove('is-open');
        otherItem.classList.remove('panel-open');
      }

      /* --- Desktop: size <select> change handler --- */
      var sizeSelect = item.querySelector('.stl-size-select');
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          if (hiddenId) hiddenId.value = this.value;
          if (notSelected) notSelected.classList.remove('is-visible');
        });
      }

      /* --- Toggle panel (mobile trigger button) --- */
      if (trigger && panel) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          if (panel.classList.contains('is-open')) {
            closePanel();
          } else {
            openPanel();
          }
        });
      }

      /* --- Close button inside panel --- */
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closePanel();
        });
      }

      /* --- Close on backdrop click --- */
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closePanel();
        });
      }

      /* --- "TOEVOEGEN" button: opens panel on mobile, adds to cart on desktop --- */
      var addBtn = item.querySelector('.stl-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var isDesktop = window.innerWidth >= 990;

          if (isDesktop) {
            // Desktop: add to cart using the <select> value
            var selectedId = sizeSelect ? sizeSelect.value : null;
            if (!selectedId) {
              if (notSelected) {
                notSelected.classList.add('is-visible');
              }
              return;
            }
            addToCart(parseInt(selectedId), item, cartQuantities, function () {
              // Reset select after successful add
              if (sizeSelect) sizeSelect.selectedIndex = 0;
            });
          } else {
            // Mobile: toggle the slide-up panel
            if (panel) {
              if (panel.classList.contains('is-open')) {
                closePanel();
              } else {
                openPanel();
              }
            }
          }
        });
      }

      /* --- Variant selection --- */
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (hiddenId) hiddenId.value = this.value;

          // Update trigger text with selected size
          if (trigger) {
            var label = this.nextElementSibling ? this.nextElementSibling.textContent.trim() : '';
            trigger.textContent = label ? label : triggerText;
          }

          if (notSelected) notSelected.classList.remove('is-visible');

          updatePanelButton(item, cartQuantities);
        });
      });

      /* --- Add to cart (mobile panel button) --- */
      if (panelBtn) {
        panelBtn.addEventListener('click', function (e) {
          e.preventDefault();

          var selected = panel ? panel.querySelector('.stl-variant-option input:checked') : null;

          if (!selected) {
            if (notSelected) notSelected.classList.add('is-visible');
            return;
          }

          addToCart(parseInt(selected.value), item, cartQuantities, function () {
            // Close panel & reset
            closePanel();
            if (trigger) trigger.textContent = triggerText;
            radios.forEach(function (r) { r.checked = false; });
          });
        });
      }
    });
  });

  /* ------------------------------------------------
   * Shared add-to-cart function (desktop + mobile)
   * ------------------------------------------------ */
  function addToCart(variantId, itemEl, cartQuantities, onSuccess) {
    var panelEl     = itemEl._stlPanel;
    var notSelected = panelEl ? panelEl.querySelector('.stl-not-selected') : null;
    var activeBtn   = (panelEl && panelEl.querySelector('.stl-panel-add-btn:not([style*="display: none"])'))
                   || itemEl.querySelector('.stl-add-btn');

    // Find inventory data from either the <select> option or the radio input
    var optionEl = itemEl.querySelector('.stl-size-select option[value="' + variantId + '"]')
                || (panelEl && panelEl.querySelector('.stl-variant-option input[value="' + variantId + '"]'));

    var inventoryQty        = optionEl ? parseInt(optionEl.dataset.inventoryQuantity) || 0 : 0;
    var inventoryManagement = optionEl ? optionEl.dataset.inventoryManagement : '';
    var inventoryPolicy     = optionEl ? optionEl.dataset.inventoryPolicy : '';
    var cartQty             = cartQuantities[variantId] || 0;

    // Inventory check
    if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue') {
      if (inventoryQty - cartQty <= 0) {
        if (notSelected) {
          notSelected.textContent = cartQty > 0
            ? 'Dit product zit al in je winkelwagen'
            : 'Uitverkocht';
          notSelected.classList.add('is-visible');
        }
        return;
      }
    }

    // Disable button
    if (activeBtn) {
      activeBtn.disabled = true;
      activeBtn.classList.add('disabled');
    }

    // Detect cart element (cart-drawer or cart-notification)
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionsToRender = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';

    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: sectionsToRender,
      sections_url: window.location.pathname
    };

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
    .then(function (response) { return response.json(); })
    .then(function (data) {
      if (data.status) {
        // Error from Shopify (e.g. out of stock)
        if (notSelected) {
          notSelected.textContent = data.description || 'Er is iets misgegaan.';
          notSelected.classList.add('is-visible');
        }
        return;
      }

      cartQuantities[variantId] = (cartQuantities[variantId] || 0) + 1;

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: data
      }));

      // Render cart contents (works for both cart-drawer and cart-notification)
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      } else {
        window.location = window.routes.cart_url;
      }

      if (typeof onSuccess === 'function') onSuccess();
    })
    .catch(function (err) {
      console.error('Shop the Look – add to cart error:', err);
      if (notSelected) {
        notSelected.textContent = 'Er is iets misgegaan. Probeer het opnieuw.';
        notSelected.classList.add('is-visible');
      }
    })
    .finally(function () {
      if (activeBtn) {
        activeBtn.disabled = false;
        activeBtn.classList.remove('disabled');
      }
    });
  }

  /* --- Close panels on outside click --- */
  document.addEventListener('click', function (e) {
    // A click "outside" means: not on a product row/trigger (.stl-product-item)
    // and not inside an open panel/backdrop (now living in the body portal).
    if (!e.target.closest('.stl-product-item') && !e.target.closest('.pdp-shop-the-look-portal')) {
      stlPortal.querySelectorAll('.stl-size-panel.is-open, .stl-backdrop.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      section.querySelectorAll('.stl-product-item.panel-open').forEach(function (el) {
        el.classList.remove('panel-open');
      });
    }
  });

  function updatePanelButton(item, cartQuantities) {
    var panelEl = item._stlPanel;
    if (!panelEl) return;
    var selected = panelEl.querySelector('.stl-variant-option input:checked');
    var panelBtn = panelEl.querySelector('.stl-panel-add-btn');
    if (!selected || !panelBtn) return;

    var variantId           = parseInt(selected.value);
    var inventoryQty        = parseInt(selected.dataset.inventoryQuantity) || 0;
    var inventoryManagement = selected.dataset.inventoryManagement;
    var inventoryPolicy     = selected.dataset.inventoryPolicy;
    var cartQty             = cartQuantities[variantId] || 0;

    if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue' && (inventoryQty - cartQty) <= 0) {
      panelBtn.classList.add('disabled');
      panelBtn.disabled = true;
    } else {
      panelBtn.classList.remove('disabled');
      panelBtn.disabled = false;
    }
  }
});
